export const FORM_GROUP_PRESETS = {
  ALL: "ALL",
};
